import { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalFooter, ModalBody, Button, Row } from 'reactstrap';
import * as actions from '../../../actions';
import EditWatermarkData from './EditWatermarkData';
import EditWatermarkPreview from './EditWatermarkPreview';
import { getTranslationKey } from '../../../modules/utils/helpers';
import type { Notify } from '../../../typings/redux';
import type { Watermark } from './types';

interface EditWatermarkProps {
  isOpen: boolean;
  watermark?: Watermark;
  toggle: () => void;
  updateWatermark: (watermark: Watermark, notify: Notify) => Promise<boolean>;
  notify: Notify;
}

interface EditWatermarkState {
  saving?: boolean;
}

class EditWatermark extends Component<EditWatermarkProps, EditWatermarkState> {
  constructor(props: EditWatermarkProps) {
    super(props);
    this.state = {};
    this.save = this.save.bind(this);
  }

  async save() {
    const { updateWatermark, notify, watermark, toggle } = this.props;
    if (!watermark) return;

    this.setState({ saving: true });
    const success = await updateWatermark(watermark, notify);
    success && toggle();
    this.setState({ saving: false });
  }

  render() {
    const { isOpen, watermark, toggle } = this.props;
    if (!watermark) return null;

    return (
      <Modal
        centered
        isOpen={isOpen}
        toggle={toggle}
        wrapClassName="modal-dark"
        size={
          watermark.type === 'text' || (watermark.type === 'image' && watermark.watermarkPublicKey)
            ? 'xl'
            : 'md'
        }
      >
        <ModalHeader toggle={toggle}>{getTranslationKey('watermark.edit')}</ModalHeader>
        <ModalBody>
          <Row>
            <EditWatermarkPreview watermark={watermark} />
            {(watermark.type === 'text' ||
              (watermark.type === 'image' && watermark.watermarkPublicKey)) && (
              <EditWatermarkData watermark={watermark} />
            )}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.save} color="success" disabled={this.state.saving}>
            {getTranslationKey('save')}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

interface StateProps {
  notify: Notify;
}

function mapStateToProps({ notify }: StateProps) {
  return { notify };
}
export default connect(mapStateToProps, actions)(EditWatermark);
